// const suiteCrmUrl = "http://loc.suitecrm.com.au/";
// const suiteCrmUrl = "http://suite-dev.local/";
const suiteCrmUrl = "https://suitecrm.pure-electric.com.au/";
const getStcVeec = "index.php?entryPoint=APTGetSTCVEEC";
const checkEmailLead = "index.php?entryPoint=APIGetLeadByEmail";
const getSMSTemplate = "index.php?entryPoint=APIGetSMSTemplateFromSuiteById";
const getSMSSignatureTemplate = "index.php?entryPoint=APTGetSignatureUser";
const getNote = "index.php?entryPoint=CRUD_quote_note";
const getDaikinProduct = 'index.php?entryPoint=APIGetDaikinProduct';
const generateQuote = "index.php?entryPoint=APIGenerateQuoteDaikinApp";
const saveAndSendPdf = "index.php?entryPoint=APISavePDFAndEmail";
const downloadFileFromPath = "index.php?entryPoint=APIDownloadFileFromPath";
const sendSMS = "index.php?entryPoint=APISendSMS";
const getDataLead = "index.php?entryPoint=APIGetDataLeads";
const getLeadSource = "index.php?entryPoint=APIGetOptionsDropdown";
const userAuth = "index.php?entryPoint=APIUserAuth";
const getPEAdmin = "index.php?entryPoint=APIGetProductByCategory&category=PE%20Admin%20Fees";

const formName = 'daikin-form';

export {
  suiteCrmUrl,
  getStcVeec,
  checkEmailLead,
  getSMSTemplate,
  getSMSSignatureTemplate,
  getNote,
  generateQuote,
  saveAndSendPdf,
  downloadFileFromPath,
  sendSMS,
  getDataLead,
  getLeadSource,
  getDaikinProduct,
  formName,
  userAuth,
  getPEAdmin,
}